
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recipes/r/[slug]",
      function () {
        return require("private-next-pages/recipes/r/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recipes/r/[slug]"])
      });
    }
  